import React, { useState, useRef, useEffect } from "react";
import "./MenuCard.css";
import { Link, useNavigate } from "react-router-dom";
import { FaMapSigns, FaMinus, FaPlus } from "react-icons/fa";
import { BiMenu } from "react-icons/bi";
import { CiMapPin, CiMenuBurger } from "react-icons/ci";
import { GiPlateClaw } from "react-icons/gi";
import { IoRestaurant } from "react-icons/io5";
import { MdRestaurant } from "react-icons/md";
import menu from "../../MENULIST/Palwal/GrandPrakashMenu";
import { BsFillStarFill, BsInstagram, BsStarFill } from "react-icons/bs";
import { HiMapPin } from "react-icons/hi2";

const MenuCardParty = ({ menu, metaData, code, table }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRefs = useRef({});
  const categoryRefs = useRef({});
  const [savedItems, setSavedItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const storedItems = JSON.parse(sessionStorage.getItem("savedItems")) || [];
    setSavedItems(storedItems);
    sessionStorage.setItem("whatsappNo", metaData.whatsappNo);
    sessionStorage.setItem("tableNo", table);

    const handleScroll = () => {
      menu.forEach((section) => {
        const categoryRef = categoryRefs.current[section.category];
        if (categoryRef) {
          const categoryTop = categoryRef.getBoundingClientRect().top;
          const categoryBottom = categoryRef.getBoundingClientRect().bottom;
          if (categoryTop <= 0 && categoryBottom > 0) {
            categoryRef.classList.add("sticky", "top-0", "z-10");
          } else {
            categoryRef.classList.remove("sticky", "top-0", "z-10");
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  console.log({ menu });
  const categories = menu.map((cat) => ({
    name: cat.category,
    refKey: cat.category,
  }));

  const scrollToCategory = (category) => {
    menuRefs.current[category].scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    setIsMenuOpen(false);
  };

  const addToCart = (item) => {
    setSavedItems((prevItems) => {
      const itemKey = item.size ? `${item.id}-${item.size}` : `${item.id}`;
      const existingItem = prevItems.find(
        (savedItem) => savedItem.id === item.id && savedItem.size === item.size
      );
      let updatedItems;
      if (existingItem) {
        updatedItems = prevItems.map((savedItem) =>
          savedItem.id === item.id && savedItem.size === item.size
            ? { ...savedItem, quantity: savedItem.quantity + 1 }
            : savedItem
        );
      } else {
        updatedItems = [...prevItems, { ...item, quantity: 1 }];
      }
      sessionStorage.setItem("savedItems", JSON.stringify(updatedItems));
      return updatedItems;
    });
  };

  const removeFromCart = (item) => {
    setSavedItems((prevItems) => {
      const existingItem = prevItems.find(
        (savedItem) => savedItem.id === item.id && savedItem.size === item.size
      );
      let updatedItems;
      if (existingItem.quantity > 1) {
        updatedItems = prevItems.map((savedItem) =>
          savedItem.id === item.id && savedItem.size === item.size
            ? { ...savedItem, quantity: savedItem.quantity - 1 }
            : savedItem
        );
      } else {
        updatedItems = prevItems.filter(
          (savedItem) =>
            !(savedItem.id === item.id && savedItem.size === item.size)
        );
      }
      sessionStorage.setItem("savedItems", JSON.stringify(updatedItems));
      return updatedItems;
    });
  };

  return (
    <div className="p-4 bg-gradient-to-br from-pink-200 to-custom-dark/10 min-h-screen relative">
      {/* Restaurant Header */}
      <div
        className="relative bg-gradient-to-br from-red-200 to-pink-300 rounded-3xl shadow-2xl p-8 mb-8 overflow-hidden"
        back
      >
        {/* Abstract Background Shapes (Optional) */}
        <div className="absolute inset-0 animate-pulse opacity-20">
          <div className="absolute top-0 left-0 w-32 h-32 bg-pink-200 rounded-full blur-2xl"></div>
          <div className="absolute bottom-10 right-10 w-48 h-48 bg-purple-200 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 text-center">
          {/* <h1 className="text-4xl font-script font-bold text-white drop-shadow-lg mb-3 tracking-wide">
            Happy Wedding
          </h1> */}
          <img
            src={require("../../assets/images/menu/pngegg (1).png")}
            alt="Enjoy the Meal"
            className="w-full mx-auto mt-3 mb-4 "
          />
          <h1 className="text-3xl font-script text-red-900 drop-shadow-lg mb-3 tracking-wide">
            Rohini & Rohit
          </h1>
          {/* <h1 className="text-4xl font-script text-white drop-shadow-lg mb-3 tracking-wide">
            &
          </h1>
          <h1 className="text-4xl font-script text-white drop-shadow-lg mb-3 tracking-wide">
            Rohini
          </h1> */}
          <h2 className="text-xl font-bold  italic mb-5 tracking-wider text-pink-800">
            Catering by Goyal Catering Services
          </h2>
          <div className="flex justify-center space-x-4">
            {metaData.reviewLink && (
              <button
                className="flex items-center justify-center space-x-2 bg-white bg-opacity-80 text-pink-800 rounded-full shadow-md px-5 py-2 hover:bg-opacity-90 transition-colors duration-300"
                onClick={() => window.open(metaData.reviewLink, "_blank")}
              >
                <BsFillStarFill className="w-5 h-5 text-orange-500" />
                <span className="font-semibold">Review</span>
              </button>
            )}
            <button
              className="flex items-center justify-center space-x-2 bg-white bg-opacity-80 text-pink-800 rounded-full shadow-md px-5 py-2 hover:bg-opacity-90 transition-colors duration-300"
              onClick={() => window.open(metaData.instagram, "_blank")}
            >
              <BsInstagram className="w-5 h-5 text-red-500" />
              <span className="font-semibold">Instagram</span>
            </button>
          </div>
        </div>
      </div>

      {/* Menu */}
      {menu.map((section, index) => (
        <div
          key={index}
          ref={(el) => (menuRefs.current[section.category] = el)}
        >
          <div
            ref={(el) => (categoryRefs.current[section.category] = el)}
            className="sticky top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-custom-dark/10 p-3 shadow-sm"
          >
            <h2 className="text-xl font-bold text-pink-800 flex items-center gap-2">
              <IoRestaurant className="text-custom-dark" />
              {section.category}
            </h2>
          </div>
          <div className="mt-3">
            <div className="space-y-4">
              {section.items.map((item) => {
                let cartItem = savedItems.find(
                  (savedItem) =>
                    savedItem.id === item.id && savedItem.size === item.size
                );

                return (
                  <div
                    key={`${item.id}-${item.size || "default"}`}
                    className="bg-white p-4 rounded-xl shadow-md border border-custom-dark/10"
                  >
                    <div className="flex items-start gap-4">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-24 h-24 object-cover rounded-lg shadow-sm"
                      />
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <h3 className="text-lg font-bold text-custom-dark flex-1">
                            {item.name}
                          </h3>
                          {item.size && (
                            <span className="bg-gradient-to-r from-custom-dark to-pink-800 text-white  px-2 py-1 rounded text-sm font-semibold">
                              {item.size}
                            </span>
                          )}
                        </div>
                        <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                          {item.description}
                        </p>
                        <div className="flex items-center justify-between mt-3">
                          <span className="text-base font-bold text-pink-800">
                            Goyal Catering Services
                          </span>
                          {cartItem ? (
                            <div className="flex gap-2 items-center">
                              <button
                                onClick={() => removeFromCart(item)}
                                className="p-2 bg-pink-400 text-white rounded-full hover:bg-red-600 transition-colors duration-300"
                              >
                                <FaMinus className="text-sm" />
                              </button>
                              <span className="text-base font-bold text-custom-dark">
                                {cartItem.quantity}
                              </span>
                              <button
                                onClick={() => addToCart(item)}
                                className="p-2 bg-pink-700 text-white rounded-full hover:bg-pink-800/80 transition-colors duration-300"
                              >
                                <FaPlus className="text-sm" />
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => addToCart(item)}
                              className={`px-3 py-1 rounded-full text-sm ${
                                item.available
                                  ? "bg-pink-700 text-white hover:bg-pink-800/80"
                                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
                              } transition-colors duration-300`}
                              disabled={!item.available}
                            >
                              Add
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}

      {/* Floating Menu Button */}
      <div className="fixed bottom-16 right-4 z-50">
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="bg-gradient-to-r from-custom-dark to-pink-800 text-white p-3 rounded-full shadow-xl flex items-center gap-2"
        >
          <MdRestaurant className="text-2xl" />
          <span className="text-base font-bold">Menu</span>
        </button>

        {isMenuOpen && (
          <div className="absolute bottom-14 right-0 bg-gradient-to-r from-custom-dark to-pink-800/80 text-white rounded-xl shadow-xl w-48 p-3 max-h-[40vh] overflow-y-auto">
            {categories.map((category, index) => (
              <button
                key={index}
                className=" w-full text-left px-3 py-2 bg-custom-dark/80 hover:bg-custom-dark rounded-md transition-colors duration-300 flex items-center gap-2 mt-1 text-sm"
                onClick={() => scrollToCategory(category.refKey)}
              >
                <IoRestaurant className="text-pink-800" />
                {category.name}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Cart Footer */}
      <div
        onClick={() =>
          navigate("/menu/saved-items-party", { state: { savedItems } })
        }
        className="fixed w-full left-0 bottom-0 bg-gradient-to-r from-custom-dark to-pink-800 text-white px-4 py-3 shadow-xl h-16 flex items-center justify-between"
      >
        <span className="flex items-center gap-2 text-base">
          <GiPlateClaw className="text-yellow-300" />
          Cart ({savedItems.length})
        </span>
        <span className="text-base font-semibold">Confirm Your Order 🛒</span>
      </div>
    </div>
  );
};

export default MenuCardParty;
